import React from 'react';

import { ACTION, STATUS } from '../../../constants';

import Button, { buttonColor } from 'Components/Button';
import EditApplicationButton from 'Components/EditApplicationButton';

export default ({status, readableStatus, handleGoBackClick, isDetails, inspection, user, actions, performAction, id}) => {
  const _getStatusColor = () => {
    if (user.isInspector()) {
      if (inspection && inspection.status) {
        return inspection.status.toString().toLowerCase();
      }
    } else {
      if (inspection.status === STATUS.COMPLETE) {
        if (inspection.vresponseRequired) {
          if (inspection.response && inspection.response.status) {
            return inspection.response.status.toString().toLowerCase();
          }
        } else {
          if (inspection && inspection.status) {
            return inspection.status.toString().toLowerCase();
          }
        }
      } else {
        if (inspection && inspection.status) {
          return inspection.status.toString().toLowerCase();
        }
      }
    }

    return '';
  };

  return (
    <section className='scene__scene-header detailsScene__scene-header'>
      <div className='go-back-to-list-header-button' onClick={handleGoBackClick}>
        Back
      </div>
      <header className='_width_450'>Inspection Record Application</header>
      {actions.includes(ACTION.EDIT) && <EditApplicationButton onClick={performAction(ACTION.EDIT, id)} />}
      {actions.includes(ACTION.DELETE) && (
        <Button
          label={ACTION.DELETE}
          buttonClassName='_height_30 _width_100 _margin_left_10'
          onClick={performAction(ACTION.DELETE, id)}
          color={buttonColor.red}
        />
      )}
      <div className={`detailsScene__status-label ${_getStatusColor()} _width_210`}>{readableStatus.toLowerCase()}</div>
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/app/Scenes/Inspection/Details/Header.jsx